import React, { useEffect, useState, useLayoutEffect, useRef } from "react";

const CardBurnPointHistory = (props) => {
  // useEffect(() => {
  //   // console.log("props", props);
  // }, []);

  const [height, setHeight] = useState(0);
  const eleRef = useRef(null);

  useEffect(() => {
    // console.log(props.index, height, props.curHeight);
    props.setNewHeight(props.index, height);
  }, [height]);

  useLayoutEffect(() => {
    const handleResize = () => {
      setHeight(eleRef.current.offsetHeight);
    };
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <article ref={eleRef} data-year={props.year} data-month={props.month}>
      <div className="bHead">
        <p>
          {props.dataPointHistory.surveyTransaction !== null
            ? props.dataPointHistory.surveyTransaction
            : props.transactionNo}
        </p>
        <p>{props.createdDateTh}</p>
      </div>
      <div className="bDetails">
        <div className="bRow bold"></div>
        <div className="bRow">
          <p>คะแนนที่ใช้ :</p>
          <p className="textEnd">
            {props.point && parseInt(props.point).toLocaleString()} คะแนน
          </p>
        </div>
      </div>
    </article>
  );
};

export default CardBurnPointHistory;
